import * as React from 'react';
import { createStyles, Radio, Group, NumberInput } from '@mantine/core';
import { useInputState } from '@mantine/hooks';

// Styles
import { getCommonFieldStyles } from '../helpers/fieldStyles';

// Hooks
import { useFieldTranslation } from '../hooks/useFieldTranslation';

// Components
import { HelpTooltipButton } from '../../HelpTooltipButton';

// Types
import { GenericFieldProps } from '../types';

const useStyles = createStyles((theme) => {
    const commonFieldStyles = getCommonFieldStyles(theme);

    return {
        root: commonFieldStyles.root,
        input: commonFieldStyles.input,
        readonlyInput: commonFieldStyles.readonlyInput,
        label: commonFieldStyles.label,
        icon: commonFieldStyles.icon,
        error: commonFieldStyles.error,
        wrapper: commonFieldStyles.wrapper,
        readonlyWrapper: commonFieldStyles.readonlyWrapper,
        description: commonFieldStyles.description
    };
});

export interface CustomListFieldProps extends GenericFieldProps {
    key?: string;
    value?: number;
    onChange?: (val: number) => void;
}

export const ListField: React.FC<CustomListFieldProps> = ({ labelKey, parentform, targetperiod, ...props }) => {
    const { classes } = useStyles();
    const inputLabel = useFieldTranslation({
        key: labelKey,
        formData: parentform?.values,
        targetPeriod: targetperiod
    });

    return null;
};
